<template>
  <f7-page>
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader />
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>

    <div v-if="loaded">
      <div class="custom-table-container tableContainer">
        <OfferListTable :store="customStore" />
      </div>
    </div>
  </f7-page>
</template>
<script>
import OfferListTable from '@/components/OffersList/OfferListTable.vue';
import { mapState, mapActions } from 'vuex';
import EventBus from '@/services/event-bus';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  components: { OfferListTable },
  data() {
    return {
      loaded: false,
      customStore: [],
    };
  },
  computed: {
    ...mapState('contact', ['company', 'addresses']),
    ...mapState('Offers', ['presupuestos']),
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('My_offers'),
        disabled: false,
        page: 'offersList',
        active: true,
      },
    ]);
    this.setCurrentFilter('offersList');
  },
  async mounted() {
    try {
      // this.$f7.preloader.show();
      this.loaded = false;

      setTimeout(() => {
        this.applyCurrentFilters();
      }, 0);

      // CARGA INICIAL
      await this.fetchPresupuestos();
      this.customStore = this.presupuestos;

      EventBus.$on('offersList', async (estado) => {
        this.loaded = false;

        if (estado) {
          await this.fetchPresupuestos(estado);
          this.customStore = this.presupuestos;
        } else {
          await this.fetchPresupuestos();
          this.customStore = this.presupuestos;
        }

        this.loaded = true;
      });
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(error.message)
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      // this.$f7.preloader.hide();
      this.loaded = true;
    }
  },
  beforeDestroy() {
    EventBus.$off('offersList');
  },
  methods: {
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('Offers', ['fetchPresupuestos']),
    ...mapActions('filter', [
      'setCurrentFilter',
      'applyCurrentFilters',
    ]),
    ...mapActions('OffersListFilters', ['setSelectedStatuses']),
  },
};
</script>
